module.exports = __webpack_public_path__ + "img/no-data.38781666.gif";